<script setup lang="ts">
import TheAdmin from '@/components/TheAdmin.vue'
import TestataAdmin from "@/components/testate/TestataAdmin.vue";
import BreadcrumbAdmin from "@/components/breadcumbs/BreadcrumbAdmin.vue";
import {Model} from "@/app/Model";
let model: Model = Model.getReactiveInstance()
</script>
<template>
  <TestataAdmin></TestataAdmin>
  <BreadcrumbAdmin></BreadcrumbAdmin>
  <div class="container-fluid py-4 px-3 mx-auto">
    <main>
      <TheAdmin v-if="model.isAdmin"/>
      <div v-else><h3>Accesso non consentito!</h3>
        <p>Non disponi delle necessarie autorizzazioni per accedere alla pagina.</p></div>
    </main>
  </div>
</template>

